import { Component, type ReactNode } from 'react'

/** Boundary simples: mostra `fallback` se os filhos lançarem no render. */
export class ErrorBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false }
  static getDerivedStateFromError() {
    return { hasError: true }
  }
  componentDidCatch(err: unknown) {
    console.error('[ErrorBoundary]', err)
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children
  }
}
